import React from 'react';
import Independence2023 from 'views/SchoolProgram2023/components/Independence2023';

const SchoolProgrampage = () => {
  return <Independence2023 />;
};

export default SchoolProgrampage;